export const environment = {
  production: true,
  env: "posta",
  backendBaseUrl: "https://eposta.postashqiptare.al:8443",
  appName: "e-Posta",
  icon: "favicon.png",
  logo: "assets/img/logo.png",
  homeImage: "assets/img/main.png",
  homeTitle: "HomeTitlePosta",
  homeSubTitle: "HomeSubTitlePosta1 || HomeSubTitlePosta2 || HomeSubTitlePosta3",
  showDeposits: false,
  showLoans: false,
  showAccounts: false,
  showTransfers: false,
  showService: true,
  showServiceOSHEE: true,
  showServiceUK: true,
  showServiceGJOBAT: true,
  showServiceONE: false,
  showServiceALBTELECOM: true,
  showServiceKOPSHTE: true,
  showServiceDOGANA: true,
  showServiceTATIME: true,
  showMyContract: true,
  showTracking: true,
  showTransactionHistory: true,
  showTransferAnnouncement: true,
  showNotification: true,
  showAnkesa: true,
  showBranches: true,
  showPostalCode: true,
  showFooterContact: true,
  showProfileData: true,
  showProfileChangePassword: true,
  showProfileEdit: true,
  showProfileRepresentation: true,
  showTransferHistory: false,
  showMessage: false,
  showLoanEnquire: false,
  showRegister:false,
  themeColor: "#ffc20e",
  themeColorDark: "rgb(255, 174, 0)",
  newLogin: false,
  useSidebar: true,
  sidebarColor: "#6a6964",
  language: "sq", // en - english, sq - albanian
  useNewPhoneNumberFormat: false,
  allowLanguageChange: false, // Enable multi-language support
};
